/**
 * End Node Component
 */
import React, { memo } from 'react';
import { Handle, Position, NodeProps } from 'reactflow';
import { Square } from 'lucide-react';
import styles from './Nodes.module.css';

export const EndNode: React.FC<NodeProps> = memo(({ data, selected }) => {
  return (
    <div className={`${styles.node} ${styles.endNode} ${selected ? styles.selected : ''}`}>
      <Handle
        type="target"
        position={Position.Left}
        className={styles.handle}
      />
      <div className={styles.nodeContent}>
        <div className={styles.nodeIcon} style={{ backgroundColor: '#ef4444' }}>
          <Square size={16} color="white" />
        </div>
        <span className={styles.nodeLabel}>{data.label || 'End'}</span>
      </div>
    </div>
  );
});

EndNode.displayName = 'EndNode';
